import { Dispatch, SetStateAction, useEffect } from 'react'
import toast from 'react-hot-toast';

import { EvaluacionStepper, IEvaluacion } from '../constants';
import Objetivo from '../EvaluacionComponents/Objetivo';
import FormVideos from '../EvaluacionComponents/FormVideos'
import PesoEvaluacion from '../EvaluacionComponents/PesoEvaluacion'
import PorcentajeDeGrasa from '../EvaluacionComponents/PorcentajeDeGrasa';



interface Props {
  dataEvaluacion: IEvaluacion;
  objetivoActual: string;
  currentPhase: string;
  handleChange(type: string, value: string | number): void;
  setSection: Dispatch<SetStateAction<number>>;
  sexo: boolean;
}

const PesoPorcentajeSection = ({dataEvaluacion, objetivoActual, currentPhase, handleChange, sexo, setSection} : Props) => {  

  const handleNext = () => {
    let err2 = false;
    let err3 = false;
    let err4 = false;
    let err5 = false;

    if (dataEvaluacion.peso <= 0) {
      if (dataEvaluacion.porcentajeGrasa <= 4) {
        err2 = true;
        // console.log(dataEvaluacion.peso , dataEvaluacion.porcentajeGrasa);
      } else {
        err3 = true;
        // console.log(dataEvaluacion.peso)
      }
    }
    if (dataEvaluacion.peso > 0 && dataEvaluacion.porcentajeGrasa <= 4) {
      return err4 = true;
    }

    if(showGoalSection(currentPhase, dataEvaluacion.mes)) {
      if(dataEvaluacion.objetivo === '' || dataEvaluacion.objetivo === undefined || dataEvaluacion.objetivo === null){
        err5 = true;
      }
    }

    if (err2) {
      toast.error('Por favor coloca tu peso y porcentaje de grasa');
      return;
    }
    if (err3) {
      toast.error('Por favor coloca tu peso');
      return;
    }
    if (err4) {
      toast.error('Por favor coloca tu porcentaje de grasa');
      return;
    }
    if(err5){
      toast.error('Por favor selecciona un objetivo');
      return;
    }

    if(!err2 && !err3 && !err4 && !err5){
      setSection((sec:number) => sec + 1);
    }

  }

  const showGoalSection = (currentPhase: string, mes: number) => {
    if(currentPhase !== 'Nivel 1' && mes === 1) {
      return true;
    } else if ( mes === 4 || mes === 7 || mes === 10 || mes === 13 ) {
      return true;
    }
    return false;
  }

  // console.log(showGoalSection(currentPhase, dataEvaluacion.mes));

  useEffect(() => {
    const linkToTheTop = document.getElementById('GoToTheTop');
    linkToTheTop.click();
  }, [])

  return (
    <>
      <FormVideos 
        url='https://player.vimeo.com/external/1048027717.m3u8?s=1a2e3c4cc5f7848777cf16f371288002ae861fd0&logging=false'
        evaluation
        noUnderlined
      />

      <PesoEvaluacion 
        dataEvaluacion={dataEvaluacion}
        handleChange={handleChange}
      />

      <PorcentajeDeGrasa 
        handleChange={handleChange}
        sexo={sexo}
      />

      <br />

      { showGoalSection(currentPhase, dataEvaluacion.mes) && (
        <Objetivo
          dataEvaluacion={dataEvaluacion}
          objetivoActual={objetivoActual}
          handleChange={handleChange}
          // sexo={sexo}
        />
      )}

      <br />

      <EvaluacionStepper 
        handleNext={handleNext}
        setSection={setSection}
      />

    </>
  )
}

export default PesoPorcentajeSection